import * as iso3166 from 'i18n-iso-countries';

import de from 'i18n-iso-countries/langs/de.json';
import en from 'i18n-iso-countries/langs/en.json';

iso3166.registerLocale(de);
iso3166.registerLocale(en);
